<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card v-if="signInModal">
      <v-toolbar color="rgb(20,20,20)" dark flat align="center">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="title pa-0 ma-0">Sign in</p>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-container class="text-center pb-1">
        <v-col cols="12" class="ma-0 pt-0">
          <v-form ref="form1">
            <v-text-field
              v-model="signInEmail"
              prepend-inner-icon="mdi-account"
              label="Email address"
              style="max-height: 60px"
              class="mb-4"
              color="white"
              maxlength="254"
              solo-inverted
              shaped
              validate-on-blur
              :rules="emailRules"
              :disabled="signInLoading"
            ></v-text-field>
            <v-text-field
              v-model="signInPassword"
              prepend-inner-icon="mdi-key"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              label="Password"
              style="max-height: 60px"
              class="mb-4"
              color="white"
              :type="show ? 'text' : 'password'"
              maxlength="30"
              solo-inverted
              validate-on-blur
              :rules="passwordRules"
              @click:append="show = !show"
              @keyup.enter="signIn()"
              :disabled="signInLoading"
            ></v-text-field>
          </v-form>

          <v-btn
            class="mb-2"
            :dark="!signInLoading"
            block
            rounded
            large
            :loading="signInLoading"
            :color="signInLoading ? 'rgb(220,220,220)' : ''"
            @click="signIn()"
            >Sign in</v-btn
          >
          <v-btn
            class="mb-2"
            text
            small
            @click="
              resetForms();
              signInModal = false;
              forgotPasswordModal = true;
            "
            >Forgot password?</v-btn
          >
          <v-divider class="mb-4"></v-divider>
          <v-btn
            outlined
            block
            rounded
            @click="
              resetForms();
              signInModal = false;
              signUpModal = true;
            "
            >Not a member? Sign up</v-btn
          >
        </v-col>
      </v-container>
    </v-card>
    <v-card v-else-if="signUpModal">
      <v-toolbar color="rgb(20,20,20)" dark flat align="center">
        <v-btn
          class="ma-0 pa-0"
          absolute
          @click="
            resetForms();
            signUpModal = false;
            signInModal = true;
          "
          icon
          ><v-icon size="24">mdi-arrow-left</v-icon></v-btn
        >
        <v-row no-gutters>
          <v-col cols="12">
            <p class="title pa-0 ma-0">Sign up</p>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-container class="pb-1">
        <v-col cols="12" class="ma-0 pt-0">
          <v-form ref="form2">
            <v-col cols="4" class="centered text-center mt-0 pt-0 pb-1">
              <v-badge
                bordered
                class="mb-0 pb-0 clickable"
                color="grey darken-3"
                :icon="uploadedImage == null ? 'mdi-image-plus' : 'mdi-close'"
                overlap
                avatar
                offset-x="20"
                offset-y="20"
                @click.native="uploadImage()"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar
                      :color="
                        uploadedImage == null
                          ? 'grey darken-3'
                          : 'rgba(0,0,0,0)'
                      "
                      size="64"
                      v-bind="attrs"
                      v-on="on"
                      class="mb-3 justify-center"
                    >
                      <span
                        class="white--text headline"
                        v-if="
                          signUpUsername !== null &&
                            signUpUsername.length !== 0 &&
                            uploadedImage == null
                        "
                        >{{ signUpUsername.substring(0, 2) }}</span
                      >

                      <v-icon
                        class="white--text"
                        color="white"
                        size="32"
                        v-else-if="uploadedImage == null"
                        >mdi-account</v-icon
                      >

                      <img :src="uploadedImage" v-else />
                    </v-avatar>
                  </template>
                  <span>Upload an avatar</span>
                </v-tooltip>
              </v-badge>
              <!-- <span class="mt-0 pt-0 caption">128x128</span> -->
            </v-col>

            <!-- <v-btn
              color="grey darken-2"
              class="ml-4 mb-2 white--text"
            >
              Upload
              <v-icon right dark>
                mdi-cloud-upload
              </v-icon>
            </v-btn> -->

            <!-- <span style="display:block; margin-left:1px; margin-top:-10px; margin-bottom:8px; font-size:14px">(256x256)</span> -->

            <v-text-field
              v-model="signUpUsername"
              prepend-inner-icon="mdi-account"
              label="Username"
              class="mb-4"
              color="white"
              aria-autocomplete="false"
              style="max-height: 60px"
              validate-on-blur
              solo-inverted
              shaped
              :rules="usernameRules"
              :disabled="signUpLoading"
            ></v-text-field>
            <v-text-field
              v-model="signUpEmail"
              prepend-inner-icon="mdi-email"
              label="Email address"
              style="max-height: 60px"
              class="mb-4"
              color="white"
              maxlength="254"
              solo-inverted
              validate-on-blur
              :rules="emailRules"
              :disabled="signUpLoading"
            ></v-text-field>
            <v-text-field
              v-model="signUpPassword"
              prepend-inner-icon="mdi-key"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              label="Password"
              style="max-height: 60px"
              class="mb-2"
              color="white"
              :type="show2 ? 'text' : 'password'"
              maxlength="128"
              solo-inverted
              validate-on-blur
              :rules="passwordRules"
              @click:append="show2 = !show2"
              :disabled="signUpLoading"
            ></v-text-field>

            <vue-recaptcha
              ref="recaptcha"
              @verify="onVerify"
              @expired="onExpired"
              class="d-flex justify-center mb-3"
              sitekey="6LfdiekZAAAAAJJ8dhBHhu-iYasP7V5nTo8CoweR"
            ></vue-recaptcha>

            <div class="black--text text-center mb-4">
              By pressing Create Account, you agree to our
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a
                    @click.stop="$root.$TermsAndConditions.open()"
                    v-on="on"
                    >Terms of Service.</a
                  >
                </template>
                Opens in dialog
              </v-tooltip>
            </div>
          </v-form>
          <v-btn
            :dark="!signUpLoading"
            block
            rounded
            large
            :loading="signUpLoading"
            :color="signUpLoading ? 'rgb(220,220,220)' : ''"
            @click="signUp()"
            >Create Account</v-btn
          >
        </v-col>
      </v-container>
    </v-card>
    <v-card v-else-if="forgotPasswordModal">
      <v-toolbar color="rgb(20,20,20)" dark flat align="center">
        <v-btn
          class="ma-0 pa-0"
          absolute
          @click="
            resetForms();
            forgotPasswordModal = false;
            signInModal = true;
          "
          icon
          ><v-icon size="24">mdi-arrow-left</v-icon></v-btn
        >
        <v-row no-gutters>
          <v-col cols="12">
            <p class="title pa-0 ma-0">Forgot Password</p>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-container class="pb-1">
        <div class="black--text subtitle-1 text-center mb-4">
          Enter the email address of your account below to request a password
          reset email.
        </div>
        <v-col cols="12" class="ma-0 pt-0">
          <v-form ref="form3" onsubmit="return false">
            <v-text-field
              v-model="forgottenPasswordEmail"
              prepend-inner-icon="mdi-email"
              label="Email address"
              style="max-height: 60px"
              class="mb-4"
              color="white"
              maxlength="254"
              solo-inverted
              validate-on-blur
              :rules="emailRules"
              @keyup.enter="forgottenPassword()"
              :disabled="forgottenPasswordLoading"
            ></v-text-field>
          </v-form>
          <v-btn
            :dark="!forgottenPasswordLoading"
            block
            rounded
            large
            :loading="forgottenPasswordLoading"
            :color="forgottenPasswordLoading ? 'rgb(220,220,220)' : ''"
            @click="forgottenPassword()"
            >Send password reset email</v-btn
          >
        </v-col>
      </v-container>
    </v-card>
    <v-card v-else-if="resetPasswordModal">
      <v-toolbar color="rgb(20,20,20)" dark flat align="center">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="title pa-0 ma-0">Reset Password</p>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-container class="pb-1">
        <div class="black--text subtitle-1 text-center mb-3">
          Enter your new password.
        </div>
        <v-col cols="12" class="ma-0 pt-0">
          <v-form ref="form4" onsubmit="return false">
            <v-text-field
              v-model="resetPassword"
              prepend-inner-icon="mdi-key"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              label="New Password"
              style="max-height: 60px"
              class="mb-4"
              color="white"
              :type="show ? 'text' : 'password'"
              maxlength="128"
              solo-inverted
              validate-on-blur
              :rules="passwordRules"
              @click:append="show = !show"
              @keyup.enter="resetPasswordF()"
              :disabled="resetPasswordLoading"
            ></v-text-field>
          </v-form>
          <v-btn
            :dark="!resetPasswordLoading"
            block
            rounded
            large
            :loading="resetPasswordLoading"
            :color="resetPasswordLoading ? 'rgb(220,220,220)' : ''"
            @click="resetPasswordF()"
            >Reset Password</v-btn
          >
        </v-col>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    VueRecaptcha
  },
  data: () => ({
    dialog: false,
    show: false,
    show2: false,
    usernameRules: [
      v => !!v || "Username is required",
      v => /^[a-zA-Z0-9]+$/.test(v) || "Username contains invalid characters",
      v => (v && v.length >= 5) || "Must be >= 5 characters",
      v => (v && v.length <= 25) || "Must be <= 25 characters"
    ],
    emailRules: [
      v => !!v || "Email is required",
      v => (v && v.length >= 5) || "Must be >= 5 characters",
      v => (v && v.length <= 254) || "Must be <= 254 characters",
      v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Email is invalid"
    ],
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length >= 6) || "Must be >= 6 characters",
      v => (v && v.length <= 128) || "Must be <= 128 characters",
      v =>
        /^[A-Za-z0-9_@#&@$!*^]*$/.test(v) ||
        "Password contains invalid characters"
    ],
    signInModal: false,
    signUpModal: false,
    forgotPasswordModal: false,
    resetPasswordModal: false,
    signInEmail: null,
    signInPassword: null,
    signInLoading: false,
    signUpUsername: null,
    signUpEmail: null,
    signUpPassword: null,
    signUpCaptcha: null,
    signUpLoading: false,
    uploadedImage: null,

    forgottenPasswordEmail: null,
    forgottenPasswordLoading: false,

    resetPassword: null,
    resetPasswordLoading: false
  }),
  watch: {
    dialog: function(newV) {
      if (!newV) {
        if ("r" in this.$route.query) {
          this.$router.replace("/");
        }
      }
    }
  },
  methods: {
    open(code) {
      if (code == 0) {
        this.signInModal = true;
      } else if (code == 1) {
        this.resetPasswordModal = true;
      }

      this.resetForms();

      this.dialog = true;
    },
    resetForms() {
      this.$nextTick(() => {
        if (this.$refs["form1"]) {
          this.$refs.form1.resetValidation();
        }
        if (this.$refs["form2"]) {
          this.$refs.form2.resetValidation();
        }
      });
      this.show = false;

      this.signInEmail = null;
      this.signInPassword = null;
      this.signInLoading = false;

      this.signUpUsername = null;
      this.signUpEmail = null;
      this.signUpPassword = null;
      this.signUpCaptcha = null;
      this.signUpLoading = false;

      this.resetPassword = null;
      this.resetPasswordLoading = null;

      this.forgottenPasswordEmail = null;
      this.forgottenPasswordLoading = false;

      this.uploadedImage = null;
    },
    signIn() {
      if (this.$refs.form1.validate()) {
        let object = {
          email: this.signInEmail,
          password: this.signInPassword
        };

        this.signInLoading = true;
        this.$socket.emit("sign in", object, response => {
          this.signInLoading = false;
          if (response.error) {
            switch (response.code) {
              case 0:
                this.$root.$alert("Error", "An unknown error has occured.", {
                  color: "red"
                });
                break;
              case 1:
                this.$root.$alert(
                  "Error",
                  "No account exists with that email address.",
                  { color: "red" }
                );
                break;
              case 2:
                this.$root.$alert("Error", "Invalid credentials.", {
                  color: "red"
                });
                break;
              case 3:
                this.$root.$alert(
                  "Error",
                  "Your account has been locked due to too many failed attempts. Try again later.",
                  {
                    color: "red"
                  }
                );
            }
          } else {
            localStorage.setItem("token", response);
            this.$emit("login", response);

            this.dialog = false;
          }
        });
      }
    },
    onVerify: function(response) {
      this.signUpCaptcha = response;
    },
    onExpired: function() {
      this.signUpCaptcha = null;
    },
    signUp() {
      if (this.$refs.form2.validate() && this.signUpCaptcha !== null) {
        let object = {
          avatar: this.uploadedImage,
          username: this.signUpUsername,
          email: this.signUpEmail,
          password: this.signUpPassword,
          captcha: this.signUpCaptcha
        };

        this.signUpLoading = true;
        this.$socket.emit("sign up", object, response => {
          this.signUpLoading = false;
          if (response.error) {
            switch (response.code) {
              case 0:
                this.$root.$alert("Error", "An unknown error has occured.", {
                  color: "red"
                });
                break;
              case 1:
                this.$root.$alert(
                  "Error",
                  "An account already exists with that username.",
                  { color: "red" }
                );
                break;
              case 2:
                this.$root.$alert(
                  "Error",
                  "An account already exists with that email address.",
                  { color: "red" }
                );
                break;
              case 3:
                this.$root.$alert(
                  "Error",
                  "Your uploaded avatar is too big in size.",
                  { color: "red" }
                );
                break;
            }
          } else {
            localStorage.setItem("token", response);
            this.$emit("login", response);

            this.dialog = false;
          }
        });
      }
    },
    uploadImage() {
      if (this.uploadedImage !== null) return (this.uploadedImage = null);
      let input = document.createElement("input");
      input.type = "file";

      let $this = this;

      input.onchange = e => {
        let file = e.target.files[0];

        let reader = new FileReader();
        reader.readAsDataURL(file); // this is reading as data url

        reader.onload = readerEvent => {
          let image = new Image();
          image.src = readerEvent.target.result;

          image.onload = function() {
            let canvas = document.createElement("canvas");
            canvas.width = 128;
            canvas.height = 128;

            canvas
              .getContext("2d")
              .drawImage(image, 0, 0, canvas.width, canvas.height);
            let dataUrl = canvas.toDataURL("image/png");

            console.log(dataUrl); //eslint-disable-line

            $this.uploadedImage = dataUrl;
          };
        };
      };

      input.click();
    },

    forgottenPassword() {
      if (this.$refs.form3.validate()) {
        let object = {
          email: this.forgottenPasswordEmail
        };

        this.forgottenPasswordLoading = true;
        this.$socket.emit("forgotten password", object, response => {
          this.forgottenPasswordLoading = false;
          if (!response) {
            this.$root.$alert("Error", "An unknown error has occured.", {
              color: "red"
            });
          } else {
            this.$root.$alert(
              "Success",
              "If the account exists, a password reset email has been sent to <b>" +
                object.email +
                ".</b>"
            );
          }
          this.forgotPasswordModal = false;
          this.signInModal = true;
          this.resetForms;
        });
      }
    },

    resetPasswordF() {
      if (this.$refs.form4.validate()) {
        let object = {
          password: this.resetPassword,
          key: this.$route.query.r
        };

        this.resetPasswordLoading = true;
        this.$socket.emit("reset password", object, response => {
          this.$router.replace("/");
          this.resetPasswordLoading = false;
          if (!response.success) {
            switch (response.code) {
              case 0:
                this.$root.$alert("Error", "An unknown error has occured.", {
                  color: "red"
                });
                break;
              case 1:
                this.$root.$alert(
                  "Error",
                  "The link used was expired. Please request another.",
                  {
                    color: "red"
                  }
                );
                break;
            }
          } else {
            this.$root.$alert("Success", "Your password was reset.");
          }
          this.resetPasswordModal = false;
          this.signInModal = true;
        });
      }
    }
  }
};
</script>
